import { AppNode } from "@features/builder/graph/types"
import { nodesGroupMapper } from "@features/builder/helpers/nodesGroupMapper"

/**
 * Use to delete selected nodes and their child nodes/groups from the graph.
 *
 * Recursively includes:
 * - All selected nodes
 * - All child nodes belonging to selected groups
 * - All child groups belonging to selected groups
 *
 * @param nodes - Array of all nodes in the graph
 * @returns Array of deleted nodes
 */
export function getNodesToDelete(nodes: AppNode[]) {
  const mapper = nodesGroupMapper(nodes)

  let nodesIdsToDelete = new Set<string>()

  // Collect IDs of nodes to delete (selected nodes + their children)
  for (const node of nodes) {
    if (!node.selected) continue

    const currentNodeId = node.id
    const subNodesIds = new Set(mapper.groupToNodesIdsMapDeep.get(node.id) ?? [])
    const subGroupsIds = new Set(mapper.parentToChildGroupsIdsMapDeep.get(node.id) ?? [])

    nodesIdsToDelete.add(currentNodeId)

    // Add child nodes and groups to deletion set
    nodesIdsToDelete = nodesIdsToDelete.union(subNodesIds)
    nodesIdsToDelete = nodesIdsToDelete.union(subGroupsIds)
  }

  // Build array of remaining nodes
  const allNodes: AppNode[] = []
  for (const id of nodesIdsToDelete.values()) {
    const node = mapper.allMap.get(id)
    if (node) allNodes.push(node)
  }

  return allNodes
}
